import React from "react";

/**
 * Consistent section wrapper — eyebrow kicker + title + optional subtitle.
 */
const Section = ({
  id,
  eyebrow,
  eyebrowColor = "#ff2a8f",
  title,
  subtitle,
  children,
  className = "",
  testid,
}) => (
  <section
    id={id}
    data-testid={testid}
    className={`relative z-10 py-14 md:py-20 ${className}`}
  >
    <div className="max-w-[1500px] mx-auto px-6 md:px-12">
      {eyebrow || title || subtitle ? (
        <header className="mb-12 md:mb-14">
          {eyebrow && (
            <p
              className="inline-flex items-center gap-2 text-[11px] tracking-[0.4em] uppercase font-extrabold mb-5"
              style={{ color: eyebrowColor }}
            >
              <span
                className="inline-block w-7 h-px"
                style={{ background: eyebrowColor }}
              />
              {eyebrow}
            </p>
          )}
          {title && (
            <h2
              className="font-black uppercase leading-[0.92]"
              style={{
                fontFamily: "'Azeret Mono', monospace",
                letterSpacing: "-0.04em",
                fontSize: "clamp(2.2rem, 6vw, 4.6rem)",
              }}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
          {subtitle && (
            <p
              className="mt-5 max-w-2xl text-base md:text-lg leading-relaxed"
              style={{ color: "#cfcfc4" }}
              dangerouslySetInnerHTML={{ __html: subtitle }}
            />
          )}
        </header>
      ) : null}
      {children}
    </div>
  </section>
);

export default Section;
